import React, { useEffect, useState } from 'react';
import { IonLoading } from '@ionic/react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Route, Redirect } from 'react-router-dom';

// Constants
import { APP_CONFIG } from '../constants';

// Validators
import { RoutesValidator } from '../validators';

// Components
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

// Actions
import { resetStateAction, resetTransactionAction, resetBenefitAction, resetQrAction, startGetSettingAction, authenticatedAction } from './../redux';

// Helpers
import { isAuthenticatedInAuth0 } from '../helpers';


export const SwitchRoute = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { user, isLogin } = useSelector(state => state.auth);
    
    const [checkAuth0, setCheckAuth0] = useState(false);
    const [isAuthenticated, setisAuthenticated] = useState(false);

    /**
     * Lo primero que hago al montarse el componente, es averiguar si está autenticado
     */
    useEffect(() => {
        
        async function checkAuth() {

            const isAuth = await isAuthenticatedInAuth0();
            
            dispatch(authenticatedAction(isAuth));
            setisAuthenticated(isAuth);
            setCheckAuth0(true);
        };

        checkAuth();
        
    }, []);

    useEffect(() => {

        // Si está autenticado y no viene del Login, consulto el gonogo
        if (isAuthenticated && !isLogin) {

            dispatch(startGetSettingAction());
        }

    }, [isAuthenticated]);

    useEffect(() => {

        const unregister = history.listen((location) => {

            // Esto es cuando se hace un back
            if (history.action === 'POP') {

                const paths = location.pathname.split('/');
                if (paths.length > 0) {

                    const value = '/' + paths[1];
                    switch (value) {

                        case APP_CONFIG.PAGES.QR_SCAN.path:

                            dispatch(resetTransactionAction());
                            dispatch(resetBenefitAction());
                            dispatch(resetQrAction());
                            RoutesValidator.validatePageQrScan(history, APP_CONFIG.PAGES.QR_SCAN);
                            break;

                        case APP_CONFIG.PAGES.DOCUMENT.path:

                            dispatch(resetTransactionAction());
                            dispatch(resetBenefitAction());

                            break;

                        case APP_CONFIG.PAGES.BENEFIT.path:

                            dispatch(resetBenefitAction());
                            dispatch(resetTransactionAction());
                            dispatch(resetQrAction());
                            break;

                        case APP_CONFIG.PAGES.DETAIL.path:
                            dispatch(resetTransactionAction());
                            dispatch(resetBenefitAction());
                            break;

                        case APP_CONFIG.PAGES.HISTORY.path:
                            dispatch(resetStateAction());
                            break;

                        default:
                            break;
                    }
                }
            }
        });

        return () => {

            unregister();
        }

    }, []);

    const svg = (<svg width="100" height="100" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 17C11.2378 17 11.4692 17.0277 11.6911 17.0801C12.4122 17.2503 12.5082 18.1335 12.0426 18.7098C11.506 19.3737 10.4933 19.373 9.95677 18.709C9.49141 18.1331 9.5863 17.2505 10.3069 17.0801C10.5325 17.0268 10.765 16.9995 11 17ZM1.10053 1.10044C1.49123 0.709736 2.12469 0.709745 2.51538 1.10046L18.778 17.364C19.1684 17.7545 19.1684 18.3875 18.778 18.778C18.3875 19.1685 17.7544 19.1685 17.364 18.778L12.891 14.305C12.2811 14.1026 11.6426 13.9996 11 14C9.93076 14 8.92659 14.2798 8.05713 14.77C7.57561 15.0415 6.94833 14.9831 6.60112 14.553C6.25457 14.1236 6.31838 13.4886 6.78715 13.1977C7.93078 12.4879 9.24076 12.0765 10.596 12.01L7.99996 9.41401C6.89388 9.72753 5.84598 10.2124 4.89374 10.8492C4.43418 11.1565 3.80604 11.0943 3.45846 10.6644C3.11127 10.2349 3.17567 9.6019 3.63029 9.28841C4.49532 8.69192 5.4306 8.20193 6.41596 7.83001L4.13196 5.54501C3.29623 5.94299 2.49716 6.41244 1.74355 6.94781C1.29332 7.26765 0.665391 7.20395 0.318036 6.77459C-0.0293746 6.34516 0.0356088 5.71294 0.483686 5.38993C1.16849 4.89628 1.88906 4.44995 2.64096 4.05501L1.10069 2.51542C0.709851 2.12475 0.70978 1.49119 1.10053 1.10044ZM14.0525 9.42903C13.6939 9.32551 13.3601 9.14516 13.0961 8.8813L11.3687 7.15471C11.2708 7.05684 11.1384 7.00129 11 7.00001C13.7361 7.00001 16.2745 7.84486 18.3692 9.2886C18.8239 9.602 18.8885 10.2351 18.5413 10.6645C18.1938 11.0944 17.5658 11.1565 17.1064 10.8492C16.1684 10.2218 15.1384 9.74248 14.0525 9.42903ZM11 2.00001C14.9262 2.00001 18.5586 3.25681 21.5163 5.39042C21.9639 5.71326 22.0288 6.3448 21.6819 6.77396C21.3347 7.20354 20.7065 7.26714 20.2563 6.94707C17.5597 5.02997 14.3251 3.9949 11 4.00001C10.3061 4.00001 9.62216 4.04373 8.9512 4.12969C8.61689 4.17252 8.27875 4.06563 8.04057 3.82716C7.46356 3.24947 7.74437 2.27448 8.55345 2.1647C9.35341 2.05615 10.1703 2.00001 11 2.00001Z" fill="#00043A" />
    </svg>);

    // Durante el tiempo que está consultando a Auth0 si está autenticado, muestro loading
    if ( !checkAuth0 ) {

        return (<IonLoading
            isOpen={true}
            message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
        />);
    }

    return (
        <>

            {
                !user?.isAuthenticated &&
                <PublicRoute />
            }

            {
                user?.isAuthenticated &&
                <Route component={(props) => (
                    (user?.isAuthenticated)
                        ? (<PrivateRoute />)
                        : (<Redirect to={APP_CONFIG.PAGES.LOGIN.path} />)
                )}
                />
            }
        </>
    )
}